<template>
  <div
    class="vcore_input-group "
    :class="{ 'vcore_has-error': !!error, 'feedback-padding': !error }"
  >
    <label
      v-if="label"
      class="vcore_input-label"
      :class="{ 'vcore_input-label_optional': !required }"
      :style="{ color: labelColor }"
      :for="id | idFormat"
      :id="ariaLabelledBy | ariaFormat"
      >{{ label }}</label
    >
    <div class="vcore_select" :class="size">
      <select
        :value="content"
        @change="handleSelect"
        @blur="$emit('blur')"
        class="vcore_input"
        :class="{ 'vcore_input--error': !!error, [size]: !!size }"
        :name="name || label"
        :aria-labelledby="ariaLabelledBy | ariaFormat"
        :aria-invalid="`${!!error}`"
        :aria-required="`${required}`"
        :aria-errormessage="ariaErrorMessage"
        :id="id | idFormat"
      >
        <option value="" disabled hidden v-if="!!placeholder">{{
          placeholder
        }}</option>
        <option v-for="option in options" :value="option.value">{{
          option.text
        }}</option>
      </select>
    </div>
    <span class="vcore_input-addon"> </span>
    <div
      class="vcore_input-feedback feedback-position"
      :id="errorId | idFormat"
      v-if="error"
      aria-live="assertive"
    >{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "Select",
  props: {
    options: {
      type: Array,
      required: true,
      default: []
    },
    label: String,
    name: String,
    value: {},
    placeholder: String,
    labelStyle: String,
    inputStyle: String,
    size: {
      default: ""
    },
    labelColor: String,
    maskOptions: Object,
    required: Boolean,
    error: String,
    formName: String
  },
  data() {
    return {
      content: this.value
    };
  },
  computed: {
    id() {
      if (this.formName) {
        return `${this.formName}_${this.label}`;
      }
      return this.label;
    },

    ariaLabelledBy() {
      return `${this.id}--label`;
    },

    ariaErrorMessage() {
      return this.error ? this.$options.filters.idFormat(this.errorId) : undefined;
    },

    errorId() {
      return `${this.id}--error`;
    }
  },
  watch: {
    value() {
      this.content = this.value;
    }
  },
  methods: {
    handleSelect(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
select.vcore_input {
  &.small {
    height: 30px;
  }

  &.large {
    height: 50px;
  }
}

.vcore_select.large {
  &::before,
  &::after {
    line-height: 50px;
  }
}

.feedback-position {
  position: absolute;
}
</style>
